module.exports = __webpack_public_path__ + "img/icon-restaurant-settingshop.817aab20.png";